import comboComponent from "@/components/child/form/combo.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import UsuarioModel, { UsuarioListParameters } from "@/models/usuarioModel";
import grupoService from "@/services/grupoService";
import UsuarioService from "@/services/usuarioService";
import vendedorService from "@/services/vendedorService";
import { Getters } from "@/store/store";
import { mapGetters } from "vuex";
import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component({
    components: {
        comboComponent,
    },
    computed: {
        ...mapGetters(["VALIDAR_PERMISSAO_USUARIO"] as Getters),
    },
})
export default class UsuarioListComponent extends ListComponentBase<UsuarioModel> {
    // State computed props
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nome", "Nome", GridColumnType.String),
            new GridColumn("email", "E-mail", GridColumnType.String),
            new GridColumn("gruposDescricao", "Grupos", GridColumnType.String),
            new GridColumn("ativo", "Ativo", GridColumnType.Boolean, false, false, "", "", false, false),
        ];
    }

    situacaoUsuarioOptions: Array<Object> = [
        { text: "Usuários Ativos", value: 1 },
        { text: "Usuários Inativos", value: 0 },
    ];
    grupoUsuarioOptions: Array<Object> = [];
    isHidden = false;
    situacaoUsuarioFiltro?: number = null;
    grupoUsuarioFiltro?: number = null;

    private beforeMount() {
        this.setProps(new UsuarioService(), "usuario", "nome");
        this.filtros = [null, null];
    }

    public async onSucessoExclusao() {
        await vendedorService.comboCached(this.usuarioLogado.franquiaId, true);
    }

    private getFormValues() {
        this.filtros = [];
        this.filtros.push(this.situacaoUsuarioFiltro);
        this.filtros.push(this.grupoUsuarioFiltro);
        this.pageIndex = 1;
        this.isHidden = false;
        this.load();
    }

    public async loadMethod() {
        const somenteAtivos = this.filtros[0] == null ? null : Boolean(this.filtros[0]);
        const grupoId = this.filtros[1];

        const customParameters: UsuarioListParameters = {
            somenteAtivos: somenteAtivos,
            grupoId: grupoId,
        };

        return await this.service
            .list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
                customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<UsuarioModel>>();
    }

    public async afterLoadPagination() {
        if (this.paginationParams != null && this.paginationParams.filtros != null) {
            this.filtros = this.paginationParams.filtros;
            if (this.filtros.length > 0) {
                this.situacaoUsuarioFiltro = <number>this.filtros[0];
            }
            if (this.filtros.length > 1) {
                this.grupoUsuarioFiltro = <number>this.filtros[1];
            }
        }
    }

    public async afterMounted() {
        const grupos = await grupoService.comboCached(this.usuarioLogado.franquiaId!);
        this.grupoUsuarioOptions = grupos.map(grupo => ({
            value: grupo.id,
            text: grupo.descricao,
        }));
    }
}
